import { useState } from "react";
import { createContainer } from "unstated-next";
import { NotificationTabType } from "../constants";

export function useNotificationStoreHook() {
  const [currentNotificationTab, setCurrentNotificationTab] =
    useState<NotificationTabType>(NotificationTabType.BillingMessage);
  const [billingSelectIds, setBillingSelectIds] = useState([] as number[]);
  const [noReadNum, setNoReadNum] = useState([0, 0]);
  const [totalNum, setTotalNum] = useState(0);
  return {
    noReadNum,
    setNoReadNum,
    currentNotificationTab,
    setCurrentNotificationTab,
    billingSelectIds,
    setBillingSelectIds,
    totalNum,
    setTotalNum,
  };
}

const NotificationStoreContainer = createContainer(useNotificationStoreHook);
export const NotificationStoreContainerProvider =
  NotificationStoreContainer.Provider;

export function useNotificationStore() {
  return NotificationStoreContainer.useContainer();
}
